import React from 'react';
import { Container, Row, Col, Card, Table, ProgressBar } from "react-bootstrap";
import DashboardSideNav from '../components/dashboardSidenav';
import DashboardHeader from '../components/dashboardHeader';
import Statistics from '../components/statistics';
import Payments from '../components/payments';
import DashboardSummary from '../components/dashboardSummery';

const PaymentsPage = () => {
    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <DashboardSideNav />

            {/* Main Content */}
            <div className="main-content">
                <DashboardHeader />

                <Container fluid>
                    <Row>
                        {/* Left Column */}
                        <Col lg={9}>
                            <DashboardSummary />
                            <Payments />
                        </Col>

                        {/* Right Column */}
                        <Col lg={3}>
                            <Statistics preview={true} />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
};

export default PaymentsPage;
